import React, { useState } from 'react';
import { LabelDiv } from '@ui-library/typography';
import { SubHeader } from '@components/sources/source/warehouseSource/configureData/style';
import Table from '@ui-library/table';
import { IColumn } from '@components/sources/source/warehouseSource/configureData/sourceSpecificConfig';
import { Flex } from '@ui-library/misc';
import classes from '../../../common.module.scss';
import { fetchingPreviewStates } from '.';
import ErrorResponse from './errorResponse';

export interface PreviewRespProps {
  rows?: Array<Record<string, unknown>>;
  columns?: IColumn[];
  error?: string;
  rowCount?: number;
}
export const getColumnDetails = (columns: IColumn[]) =>
  columns?.map((col) => {
    const column = {
      title: () => (
        <Flex flexDirection="column">
          {col.name}
          <span className={classes.col_data_type}>({col.type})</span>
        </Flex>
      ),
      dataIndex: col.name,
      key: col.name,
      render: (data: unknown) => <span className={classes.col_view__wrapper}>{String(data)}</span>,
    };
    return column;
  });
interface PreviewProps extends PreviewRespProps {
  fetchingPreviewStatus: fetchingPreviewStates;
}

const Preview: React.FC<PreviewProps> = ({
  rows,
  error,
  fetchingPreviewStatus,
  columns,
}: PreviewProps) => {
  const [isExpanded, setExpanded] = useState(false);
  const getPreview = () => {
    if (fetchingPreviewStatus === fetchingPreviewStates.loading) {
      return <SubHeader> Fetching preview ... </SubHeader>;
    }
    if (
      (fetchingPreviewStatus === fetchingPreviewStates.failed ||
        fetchingPreviewStatus === fetchingPreviewStates.notStarted) &&
      error
    ) {
      return <ErrorResponse error={error} isExpanded={isExpanded} setExpanded={setExpanded} />;
    }
    if (!rows || !columns) {
      return <SubHeader> Click on Run Query to fetch the preview data</SubHeader>;
    }
    const cols = getColumnDetails(columns);
    return (
      <Table data-testid="previewTable" columns={cols} dataSource={rows} scroll={{ x: '100%' }} />
    );
  };
  return (
    <>
      <LabelDiv className="m-t-lg m-b-sm">Preview (First 50 rows)</LabelDiv>
      <div>{getPreview()}</div>
    </>
  );
};
export default Preview;
